import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { UnauthorizedInterceptor } from '../interceptors/unauthorized.interceptor';

export function provideInterceptors(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor, // Handles 401 errors
      multi: true
    }
  ]);
}
